export const coinsHead = [
  {
    title: "№",
    key: "_index",
  },
  {
    title: "quote_currency",
    key: "currency",
  },
  {
    title: "bot_single.amount",
    key: "amount",
  },
  {
    title: "bot_single.stake_amount",
    key: "stake_amount",
  },
  {
    title: "bot_single.open_rate",
    key: "open_rate",
  },
  {
    title: "bot_single.current_rate",
    key: "current_rate",
  },
  {
    title: "bot_single.current_profit",
    key: "current_profit",
  },
  {
    title: "bot_single.open_date",
    key: "open_date",
  },
  {
    title: "sell_bot",
    key: "sell",
  },
];
export const historyCoinsHead = [
  {
    title: "№",
    key: "_index",
  },
  {
    title: "quote_currency",
    key: "currency",
  },
  {
    title: "bot_single.amount",
    key: "amount",
  },
  {
    title: "bot_single.stake_amount",
    key: "stake_amount",
  },
  {
    title: "bot_single.open_rate",
    key: "open_rate",
  },
  {
    title: "bot_single.close_rate",
    key: "close_rate",
  },
  {
    title: "bot_single.profit",
    key: "profit",
  },
  {
    title: "bot_single.open_date",
    key: "open_date",
  },
  {
    title: "bot_single.close_date",
    key: "close_date",
  },
  {
    title: "bot_single.close_reason",
    key: "close_reason",
  },
];

export const botPerformanceHead = [
  {
    title: "pair",
    key: "pair",
  },
  {
    title: "bot_single.profit",
    key: "profit",
  },
  {
    title: "profit_ustd",
    key: "profit_abs",
  },
  {
    title: "count",
    key: "count",
  },
];
export const coins = [
  {
    id: 1,
    pair: "MATIC/USDT",
    base_currency: {
      coin: {
        image_svg: "/images/fake/fake-coin.svg",
      },
    },
    profit_abs: "200154",
    profit: "200154",
    count: "4",
  },
  {
    id: 1,
    pair: "MATIC/USDT",
    base_currency: {
      coin: {
        image_svg: "/images/fake/fake-coin.svg",
      },
    },
    profit_abs: "200154",
    profit: "200154",
    count: "4",
  },
];
